<template>
    <b-modal :id="$id('budgetCodeModal')" :visible="visible" hide-footer centered no-close-on-backdrop size="lg">
        <template #modal-header="{ close }">
            <b-row class="w-100 p-0 m-0 h-100 " align-v="center">
                <b-col cols="3" class="p-0 h-100 text-left">
                    <b-button :variant="'outline-' + Variant" @click="formatBudgetCode(); close(); visible = false">
                         <!-- Validate : Valider -->
                        <font-awesome-icon icon="check" class="pr-1" />{{$t('Validate')}}
                    </b-button>
                </b-col>
                <b-col cols="6" class="text-center">
                    <h6>{{$t('BudgetCodeManagement')}}</h6>
                </b-col>
                <b-col cols="3" class=" pr-0 p-1 pl-4 text-right">
                    <!-- Close : Fermer -->
                    <b-icon role="button" icon="x-lg" font-scale="1.5" @click="close(); visible = false; formula = '';formulaCode = ''" v-b-tooltip.hover :title="$t('Close')" />
                </b-col>
            </b-row>
        </template>

        <b-row>
            <!-- Selection de la nomenclature -->
            <b-col cols="12" class="py-0">
                 <!-- Nomenclature : Nomenclature -->
                <b-form-group :label="$t('Nomenclature')"
                              label-for="nomenclature"
                              label-cols-sm="2"
                              label-align-sm="left"
                              label-class="pt-2 pb-0 pr-0 ml-1"
                              class="w-100 px-0 mx-0 my-1">

                    <b-form-select id="nomenclature"
                                   :options="listItems('BudgetModel')"
                                   value-field="Id"
                                   text-field="Label"
                                   plain
                                   v-model="sModel"
                                   class="w-100"
                                   @input="populateBudgetCodes" />
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <!-- Formule du budget -->
            <b-col cols="12" class="py-0">
                <!-- Formula : Formule -->
                <b-form-group :label="$t('Formula')"
                              label-for="formula"
                              label-cols-sm="2"
                              label-align-sm="left"
                              label-class="pt-2 pb-0 pr-0 ml-1"
                              class="w-100 px-0 mx-0 my-1">

                    <b-form-input id="formula" readonly class="border" size="sm" v-model="formula" trim />
                </b-form-group>
            </b-col>
        </b-row>

        <!--<hr class="my-2 bg-dark" />-->
        <!-- Selection des données de la formule -->
        <b-row class="pt-2">
            <!-- Onglets -->
            <b-col cols="11">
                <b-tabs small pills class="w-100" fill active-nav-item-class="pb-1">
                    <b-tab v-for="budgetCodeData in budgetCodeDatas" :key="budgetCodeData.AccordionName" :title="budgetCodeData.AccordionName" class="pt-2" title-link-class="tabCodeBudgetInactive pb-1 border">
                        <b-list-group style="overflow-y:scroll; max-height:50vh;">
                            <b-list-group-item v-for="(data, index) in budgetCodeData.Data" :key="index" class="p-0 py-1">
                                <font-awesome-icon @click="addFormulaCode(data)" icon="plus" class="text-success fa-xl pr-2" role="button" />
                                {{ data.Code }} - {{ data.Name }}
                            </b-list-group-item>
                        </b-list-group>
                    </b-tab>
                </b-tabs>
            </b-col>
            
            <!-- Boutons -->
            <b-col cols="1" v-if="sModel">
                <!-- DeleteLastElement : Supprime le dernier élement de la formule -->
                <b-button block size="sm" :variant="'outline-' + Variant" v-b-tooltip.hover :title="$t('DeleteLastElement')" @click="removeLastCode">
                    <b-icon icon="backspace"></b-icon>
                </b-button>
                 <!-- AND : ET -->
                <b-button block size="sm" :variant="'outline-' + Variant" @click="addFormulaOperator('&&')">ET</b-button>
                 <!-- OR : OU -->
                <b-button block size="sm" :variant="'outline-' + Variant" @click="addFormulaOperator('||')">OU</b-button>
                <!-- OpenParenthesis : ( -->
                <b-button block size="sm" :variant="'outline-' + Variant" @click="addFormulaOperator('(')">(</b-button>
                 <!-- CloseParenthesis : ) -->
                <b-button block size="sm" :variant="'outline-' + Variant" @click="addFormulaOperator(')')">)</b-button>
            </b-col>
        </b-row>
    </b-modal>
</template>

<script lang="ts">
    import { Vue, PropSync, Watch, Prop } from 'vue-property-decorator';
    import { Getter } from 'vuex-class';
    import Component from 'vue-class-component';
    import ListItem from "@/types/fields/ListItem";
    import Dictionary from '@/types/Dictionary';
    /** Traductions */
    import locales from "./locales/CodesBudget.json";

    /** Permet d'afficher une modale pour selectionner des codes budgets selon une nomenclature */
    @Component({
        components: {

        },
        i18n: { messages: locales }
    })
    export default class CodesBudget extends Vue {
		/** Variant de couleur à appliquer sur le composant */
		@Prop({ default: () => "secondary"})
		public Variant!: string;

        /** Getter pour obtenir une liste */
        @Getter('GetListItems')
        private listItems!: (listName: string) => ListItem[];

        /** Propriété correspondant à la nomenclature selectionnée */
        @PropSync("SModel", { default: () => 0 })
        public sModel!: number;

        /** Propriété de l'affichage de la modale des budgets */
        @PropSync('Visible', { default: () => false }) /** type: boolean, */
        public visible!: boolean;

        /** Tableau des codes budget */
        private budgetCodeDatas: { AccordionName: string, Data: { Code: string, Name: string }[] }[] = [];

        /** Met à jour la nomenclature */
        @Watch('sModel', { immediate: true })
        updateBudgetModelCodes() {

            console.debug("updateBudgetModelCodes - sModel", this.sModel);
            console.debug("updateBudgetModelCodes - this.listItems('BudgetModel')", this.listItems('BudgetModel'));

            if (this.sModel && this.sModel != 0)
                this.populateBudgetCodes(this.sModel)
        }

        /**
         * Permet d'obtenir les codes busget selon l'identifiant de la nomenclature
         * @param budgetId identifiant de la nomenclature
         */
        private populateBudgetCodes(budgetId: number) {
            this.budgetCodeDatas = [];

            let budget: { Id: number, Label: string, Extras: Dictionary<any> } = this.listItems('BudgetModel').find(b => b.Id == budgetId);
            let budgetCodes: Dictionary<any> = budget.Extras.Codes;

            for (var budgetType in budgetCodes) {
                this.budgetCodeDatas.push({ AccordionName: budgetType, Data: budgetCodes[budgetType] });
            }
        }

        /** Propriété de la formule à enregistrer */
        @PropSync("SFormulaCode", { default: () => "" })
        public formulaCode!: string;

        /** Propriété de la formule à afficher */
        @PropSync("SFormula", { default: () => "" })
        public formula!: string;

        /**
         * Ajoute l'opérateur dans la formule
         * @param operator opérateur de liaison à ajouter dans la formule => ( ou ) ou || ou &&
         */
        private addFormulaOperator(operator: string) {

            let tmpFormula = this.formula; // Formule visuelle => 1 OU 3 --> value V2
            let tmpFormulaCode = this.formulaCode ? this.formulaCode : ""; // Formule masqué => [Type_:1]||[Type_:3] --> fValue V2
            let index = tmpFormulaCode ? tmpFormulaCode.length - 1 : "-1";

            switch (operator) {
                case "&&":
                    if (!tmpFormulaCode || !(tmpFormulaCode[index] == "]" || tmpFormulaCode[index] == ")"))
                        break;
                    else {
                        tmpFormulaCode += operator;
                        tmpFormula += " " + this.$t('AND').toString(); // ET
                    }
                    break;
                case "||":
                    if (!tmpFormulaCode || !(tmpFormulaCode[index] == "]" || tmpFormulaCode[index] == ")"))
                        break;
                    else {
                        tmpFormulaCode += operator;
                        tmpFormula += " " + this.$t('OR').toString(); // OU
                    }
                    break;
                case "(":
                    if (tmpFormulaCode[index] == "]") {
                        break;
                    }
                    else {
                        tmpFormulaCode += operator;

                        if (index != -1)
                            tmpFormula += " " + operator;
                        else
                            tmpFormula += operator;
                    }
                    break;
                case ")":

                    if (!tmpFormulaCode || tmpFormulaCode[index] != "]" || tmpFormulaCode.split("(").length - 1 <= tmpFormulaCode.split(")").length - 1) {
                        break;
                    }
                    else {
                        tmpFormulaCode += operator;
                        tmpFormula += operator;
                    }
                    break;
                default:
                    break;
            }

            this.formula = tmpFormula;
            this.formulaCode = tmpFormulaCode;

            console.debug("CodesBudget - addFormulaOperator - tmpFormulaCode - Fin", tmpFormulaCode);
            console.debug("CodesBudget - addFormulaOperator - tmpFormula - Fin", tmpFormula);
        }

        /**
         * Ajoute le code à la formule
         * @param code code budget selectionné à ajouter
         */
        private addFormulaCode(code: { Id: number, Code: string, Name: string, GroupType: string }) {
            let tmpFormula = this.formula; // Formule visuelle => 1 OU 3 --> value V2
            let tmpFormulaCode = this.formulaCode ? this.formulaCode : ""; // Formule masqué => [Type_:1]||[Type_:3] --> fValue V2
            let index = tmpFormulaCode ? tmpFormulaCode.length - 1 : "-1";

            if (!tmpFormulaCode || tmpFormulaCode[index] == "(") {
                tmpFormulaCode += "[" + code.GroupType + ":" + code.Id + "]";
                tmpFormula += code.Code;
            }
            else if (tmpFormulaCode[index] == "]") {
                if (tmpFormulaCode.indexOf("[" + code.GroupType + ":" + code.Id + "]") == -1) {
                    if (tmpFormulaCode.indexOf("[" + code.GroupType + ":") == -1) {
                        tmpFormulaCode += "&&[" + code.GroupType + ":" + code.Id + "]";
                        tmpFormula += " " + this.$t('AND').toString() + " " + code.Code; // ET
                    } else {
                        tmpFormulaCode += "||[" + code.GroupType + ":" + code.Id + "]";
                        tmpFormula += " " + this.$t('OR').toString() + " " + code.Code; // OU
                    }
                }
            }
            else if (tmpFormulaCode[index] == "|" || tmpFormulaCode[index] == "&") {
                tmpFormulaCode += "[" + code.GroupType + ":" + code.Id + "]";
                tmpFormula += " " + code.Code;
            }

            this.formula = tmpFormula;
            this.formulaCode = tmpFormulaCode;

            console.debug("CodesBudget - addFormulaCode - tmpFormulaCode - Fin", tmpFormulaCode);
            console.debug("CodesBudget - addFormulaCode - tmpFormula - Fin", tmpFormula);
        }

        /**
         * Supprime le dernier element ajouté à la formule
         * */
        private removeLastCode() {
            let tmpFormula = this.formula; // Formule visuelle => 1 OU 3 --> value V2
            let tmpFormulaCode = this.formulaCode ? this.formulaCode : ""; // Formule masqué => [Type_:1]||[Type_:3] --> fValue V2
            let index = tmpFormula.length - 1;

            // Suppression de la valeur affichée
            for (var i = tmpFormula.length - 1; i >= 0; i--) {
                if (tmpFormula[i] == " " || tmpFormula[i] == ")") {
                    index = i;
                    break;
                }
                else if (tmpFormula[i] == '(' && tmpFormula[index] == '(') {
                    index = i - 1;
                    break;
                }
                else if (tmpFormula[i] == '(' && tmpFormula[index] != '(') {
                    index = i + 1;
                    break;
                }

                if (i == 0)
                    index = 0
            }

            tmpFormula = tmpFormula.substring(0, index);
            this.formula = tmpFormula;

            // Suppression de la valeur masqué
            index = tmpFormulaCode.length - 1;
            if (tmpFormulaCode[index] == '&' || tmpFormulaCode[index] == '|')
                index = index - 1;
            else if (tmpFormulaCode[index] == ']') {
                for (var i = tmpFormulaCode.length - 1; i >= 0; i--) {
                    if (tmpFormulaCode[i] == '[') {
                        index = i;
                        break;
                    }

                    if (i == 0)
                        index = 0;
                }
            }
            else {
                index = index;
            }

            tmpFormulaCode = tmpFormulaCode.substring(0, index);
            this.formulaCode = tmpFormulaCode;

        }


        /**
         * Met en forme via un Regex la formule du budget à envoyer coté serveur
         */
        private formatBudgetCode(){
            const regex = new RegExp('Type[\\d*]:', 'g')
            
            console.debug("CodesBudget - formatBudgetCode - formulaCode av reg", this.formulaCode);

            let result = this.formulaCode.replace(regex, "");
            result = result.replaceAll("[", "").replaceAll("]","");
            result = result.replaceAll("&&", "&").replaceAll("||","|");

            console.debug("CodesBudget - formatBudgetCode - result", result);

            this.formulaCode = result;
        }

    }
    
</script>

<style scoped>
</style>